<div class="draw-container">
  <div *ngIf="!readOnly" class="icons">
    <a (click)="undo()"> <img src="assets\img\undo.svg" /></a>
    <a (click)="clear()"> <img src="assets\img\clean.svg" /></a>
  </div>

  <canvas #canvas></canvas>
</div>
